import React, { useContext } from "react";
import Table, {
  TableCell,
  TableRow,
  TableSectionHeader,
} from "@amzn/meridian/table";
import { FormattedMessage } from "react-intl";
import { PVAOverviewContext } from "../overview/context/PVAOverviewContext";
import {
  getDataPointRange,
  getLastDataPointRange,
  getProcessPathPlannedFPHMap,
  getPlannedFPHOfProcess,
  isValidForPlannedFph,
} from "../overview/utils/utils";
import { INDUCT, STOW } from "../overview/utils/PPAConstants";

const PackageOverviewInbound = () => {
  const { pvaData } = useContext(PVAOverviewContext);
  let shiftPlans = pvaData.shiftPlans;
  let hasPlan = shiftPlans.length === 0 ? null : shiftPlans.length;
  const lengthOfDataPointList =
    pvaData.overviewData.flowPVAData[pvaData.pvaTableData.granularity][0]
      .dataPointList.length;
  let processes = [INDUCT, STOW];
  const plannedProcessPathMap = getProcessPathPlannedFPHMap(
    shiftPlans,
    processes,
  );
  return (
    <Table headerRows={1} showDividers={false} spacing="small">
      <TableRow>
        <TableCell />
        {pvaData.overviewData.flowPVAData[
          pvaData.pvaTableData.granularity
        ][0].dataPointList.map((datapoint, index) => (
          <TableCell key={index}>
            {pvaData.overviewData.flowPVAData[
              pvaData.pvaTableData.granularity
            ][0].dataPointList.length ===
            index + 1
              ? getLastDataPointRange(
                  datapoint,
                  pvaData.overviewData.flowPVAData["15"][0].dataPointList[
                    pvaData.overviewData.flowPVAData["15"][0].dataPointList
                      .length - 1
                  ],
                )
              : getDataPointRange(
                  index,
                  pvaData.overviewData.flowPVAData[
                    pvaData.pvaTableData.granularity
                  ][0].dataPointList,
                )}
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        <TableCell width={"130px"}>
          <FormattedMessage
            id="package_overview.target_tph"
            defaultMessage="Target TPH"
          />
        </TableCell>
        {pvaData.overviewData.flowPVAData[
          pvaData.pvaTableData.granularity
        ][0].dataPointList.map((datapoint, index) => (
          <TableCell key={index}>
            {pvaData.pvaTableData.granularity !== "cumulative"
              ? index %
                  (60 / parseInt(pvaData.pvaTableData.granularity, 10)) ===
                0
                ? pvaData.targetData.NODE_TPH
                : ""
              : pvaData.targetData.NODE_TPH}
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        <TableCell>
          <FormattedMessage
            id="package_overview.actual_tph"
            defaultMessage="Actual TPH"
          />
        </TableCell>
        {pvaData.performance[pvaData.pvaTableData.granularity]
          ? pvaData.performance[pvaData.pvaTableData.granularity].map((data) =>
              data.tph === -1 ? (
                <TableCell key={data.time} />
              ) : (
                <TableCell key={data.time}>{data.tph.toFixed(0)}</TableCell>
              ),
            )
          : null}
      </TableRow>
      <TableSectionHeader>
        <FormattedMessage
          id="package_overview.inbound"
          defaultMessage="Inbound"
        />
      </TableSectionHeader>
      <TableRow>
        <TableCell>
          <FormattedMessage
            id="package_overview.predicted"
            defaultMessage="Predicted"
          />
        </TableCell>
        {pvaData.inbound.flowPVAData
          ? pvaData.inbound.flowPVAData[
              pvaData.pvaTableData.granularity
            ][1].dataPointList.map((datapoint, index) => (
              <TableCell key={index}>
                {datapoint.metricValue < 0
                  ? datapoint.metricValue === -1
                    ? "-"
                    : "0"
                  : datapoint.metricValue}
              </TableCell>
            ))
          : null}
      </TableRow>
      <TableRow>
        <TableCell>
          <FormattedMessage
            id="package_overview.actual"
            defaultMessage="Actual"
          />
        </TableCell>
        {pvaData.inbound.flowPVAData
          ? pvaData.inbound.flowPVAData[
              pvaData.pvaTableData.granularity
            ][0].dataPointList.map((datapoint, index) => (
              <TableCell key={index}>
                {datapoint.metricValue < 0
                  ? datapoint.metricValue === -1
                    ? "-"
                    : "0"
                  : datapoint.metricValue}
              </TableCell>
            ))
          : null}
      </TableRow>
      <TableSectionHeader>
        <FormattedMessage
          id="package_overview.induct"
          defaultMessage="Induct"
        />
      </TableSectionHeader>
      <TableRow>
        <TableCell>
          <FormattedMessage
            id="package_overview.required"
            defaultMessage="Required"
          />
        </TableCell>
        {isValidForPlannedFph(hasPlan, pvaData.pvaTableData.granularity)
          ? shiftPlans
              .filter((shiftPlan, index) => {
                return (
                  shiftPlan.requiredHeadcounts.Induct &&
                  index < lengthOfDataPointList
                );
              })
              .map((shiftPlan, index) => (
                <TableCell key={index}>
                  {getPlannedFPHOfProcess(
                    plannedProcessPathMap,
                    shiftPlan.timeWindow.start,
                    INDUCT,
                  )}
                </TableCell>
              ))
          : pvaData.overviewData.flowPVAData[
              pvaData.pvaTableData.granularity
            ][1].dataPointList.map((datapoint, index) => (
              <TableCell key={index}>
                {datapoint.metricValue < 0
                  ? datapoint.metricValue === -1
                    ? "-"
                    : "0"
                  : datapoint.metricValue}
              </TableCell>
            ))}
      </TableRow>
      <TableRow>
        <TableCell>
          <FormattedMessage
            id="package_overview.actual"
            defaultMessage="Actual"
          />
        </TableCell>
        {pvaData.overviewData.flowPVAData[
          pvaData.pvaTableData.granularity
        ][0].dataPointList.map((datapoint, index) => (
          <TableCell key={index}>{datapoint.metricValue}</TableCell>
        ))}
      </TableRow>
      <TableRow>
        <TableCell>
          <FormattedMessage
            id="package_overview.target_pph"
            defaultMessage="Target PPH"
          />
        </TableCell>
        {pvaData.overviewData.flowPVAData[
          pvaData.pvaTableData.granularity
        ][0].dataPointList.map((datapoint, index) => (
          <TableCell key={index}>
            {pvaData.pvaTableData.granularity !== "cumulative"
              ? index %
                  (60 / parseInt(pvaData.pvaTableData.granularity, 10)) ===
                0
                ? pvaData.targetData.INDUCT_PPH
                : ""
              : pvaData.targetData.INDUCT_PPH}
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        <TableCell>
          <FormattedMessage
            id="package_overview.actual_pph"
            defaultMessage="Actual PPH"
          />
        </TableCell>
        {pvaData.performance[pvaData.pvaTableData.granularity]
          ? pvaData.performance[pvaData.pvaTableData.granularity].map((data) =>
              data.inductPPH === -1 ? (
                <TableCell key={data.time} />
              ) : (
                <TableCell key={data.time}>
                  {data.inductPPH.toFixed(0)}
                </TableCell>
              ),
            )
          : null}
      </TableRow>
      <TableSectionHeader>
        <FormattedMessage id="package_overview.stow" defaultMessage="Stow" />
      </TableSectionHeader>
      <TableRow>
        <TableCell>
          <FormattedMessage
            id="package_overview.required"
            defaultMessage="Required"
          />
        </TableCell>
        {isValidForPlannedFph(hasPlan, pvaData.pvaTableData.granularity)
          ? shiftPlans
              .filter((shiftPlan, index) => {
                return (
                  shiftPlan.requiredHeadcounts.Stow &&
                  index < lengthOfDataPointList
                );
              })
              .map((shiftPlan, index) => (
                <TableCell key={index}>
                  {getPlannedFPHOfProcess(
                    plannedProcessPathMap,
                    shiftPlan.timeWindow.start,
                    STOW,
                  )}
                </TableCell>
              ))
          : pvaData.overviewData.flowPVAData[
              pvaData.pvaTableData.granularity
            ][3].dataPointList.map((datapoint, index) => (
              <TableCell key={index}>
                {datapoint.metricValue < 0
                  ? datapoint.metricValue === -1
                    ? "-"
                    : "0"
                  : datapoint.metricValue}
              </TableCell>
            ))}
      </TableRow>
      <TableRow>
        <TableCell>
          <FormattedMessage
            id="package_overview.actual"
            defaultMessage="Actual"
          />
        </TableCell>
        {pvaData.overviewData.flowPVAData[
          pvaData.pvaTableData.granularity
        ][2].dataPointList.map((datapoint, index) => (
          <TableCell key={index}>{datapoint.metricValue}</TableCell>
        ))}
      </TableRow>
      <TableRow>
        <TableCell>
          <FormattedMessage
            id="package_overview.target_pph"
            defaultMessage="Target PPH"
          />
        </TableCell>
        {pvaData.overviewData.flowPVAData[
          pvaData.pvaTableData.granularity
        ][0].dataPointList.map((datapoint, index) => (
          <TableCell key={index}>
            {pvaData.pvaTableData.granularity !== "cumulative"
              ? index %
                  (60 / parseInt(pvaData.pvaTableData.granularity, 10)) ===
                0
                ? pvaData.targetData.STOW_PPH
                : ""
              : pvaData.targetData.STOW_PPH}
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        <TableCell>
          <FormattedMessage
            id="package_overview.actual_pph"
            defaultMessage="Actual PPH"
          />
        </TableCell>
        {pvaData.performance[pvaData.pvaTableData.granularity]
          ? pvaData.performance[pvaData.pvaTableData.granularity].map((data) =>
              data.stowPPH === -1 ? (
                <TableCell key={data.time} />
              ) : (
                <TableCell key={data.time}>{data.stowPPH.toFixed(0)}</TableCell>
              ),
            )
          : null}
      </TableRow>
    </Table>
  );
};

export default PackageOverviewInbound;



// WEBPACK FOOTER //
// ./src/components/packageOverview/PackageOverviewInbound.js